import React from 'react';
import { Box } from '@mui/material';
import Footer from './Footer';

const PaymentLayout = ({ children }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2 // Simple padding instead of accounting for nav bar
        }}
      >
        {children}
      </Box>

      <Footer />
    </Box>
  );
};

export default PaymentLayout;
